import { connect } from 'react-redux';

import { sendExportExcelRequest } from '../TransferringRequests/transferringRequestsActions';
import ItemsCountingReport from './ItemsCountingReport';

const mapStateToProps = state => ({
  itemsCountingReport: state.items.itemsCountingReport,
  isLoading: state.items.isLoading,
  reportLoading: state.transferringRequests.reportLoading,
});

const mapDispatchToProps = dispatch => ({
  sendExportExcelRequest: (params, type) => dispatch(sendExportExcelRequest(params, type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemsCountingReport);
